import { style } from 'typestyle'
export const primaryDark = style({ color: '#3979ca' })
